import { render } from "./InputTextArea.vue?vue&type=template&id=6f2eb400&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=6f2eb400&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2eb400"]])

export default __exports__